import { useMemo } from "react";
import { useMatches, type UIMatch } from "react-router-dom";

import {
  BASE_BAR_CHART_PROPS,
  LG_BAR_CHART_SIZE,
  MAX_MD_VIEWPORT_QUERY,
  MD_BAR_CHART_SIZE,
} from "constants/charts";

import { useViewport } from "./useViewport";

export const useBaseBarChartProps = () => {
  const matchWithAxisLabels = useMatches() as Array<
    UIMatch<unknown, { yAxisLabel: string }>
  >;

  const yAxisLabelMatches = matchWithAxisLabels.find(
    (match) => match.handle?.yAxisLabel,
  );

  const matchesMdViewport = useViewport(MAX_MD_VIEWPORT_QUERY);

  const chartSize = matchesMdViewport ? MD_BAR_CHART_SIZE : LG_BAR_CHART_SIZE;
  const yAxisLabel =
    yAxisLabelMatches?.handle?.yAxisLabel ?? BASE_BAR_CHART_PROPS.yAxisLabel;

  return useMemo(
    () => ({
      ...BASE_BAR_CHART_PROPS,
      ...chartSize,
      yAxisLabel,
    }),
    [chartSize, yAxisLabel],
  );
};
